import { Session } from '~/types/tutoring-api'

export function getMeeting(session: Session): { link: string; linkType: string } {
  if (!session) {
    return {
      link: '',
      linkType: 'internal',
    }
  }

  if (session.meetings && session.meetings.room) {
    return {
      link: `/session/${session.id}`,
      linkType: 'internal',
    }
  }

  return {
    link: session.link || '',
    linkType: 'external',
  }
}
